module.exports = __WEBPACK_EXTERNAL_MODULE_70__;


//////////////////
// WEBPACK FOOTER
// external {"root":["rx","BehaviorSubject"],"commonjs":"rxjs/BehaviorSubject","commonjs2":"rxjs/BehaviorSubject","amd":"rxjs/BehaviorSubject"}
// module id = 70
// module chunks = 0